module.exports = __webpack_public_path__ + "static/media/program-learn-main-1.92dc431e.png";